export const getToolNameForUrl = (url: string) => {
  if (url === "/") {
    return "home";
  } else if (url.includes("/resource-inventory/items")) {
    return "resourcesHome";
  }

  return null;
};
